export const STORAGE_KEYS = {
  CAMPAIGN_SOCIAL_POPUP_DISMISSED: 'campaign_social_popup_dismissed',
};
